/**
 * Varianty zákazky v poradí záložiek (KOLO 206) — zrkadlo
 * `services/vyber_variant.py`.
 *
 * Server posiela varianty podľa vzniku; záložky dávajú výrobné na koniec.
 * Výber pri výstupoch a Objednávkach ide v tom istom poradí a s tými istými
 * menami, inak by „2" v PDF (`2-A1`) nesedelo s druhou záložkou.
 */
import type { Varianta } from "@/api/schemas";

type PoleVarianty = Pick<Varianta, "nazov" | "je_vyrobna" | "je_cast"> & {
  odbor?: Varianta["odbor"];
};

/** Rozpočet tovaru (KOLO 230) — regály CRC vedľa nábytku. */
export function jeTovarovaVarianta(v: { odbor?: Varianta["odbor"] }): boolean {
  return v.odbor === "tovar";
}

/** Výpočty v poradí vzniku, výrobné za nimi, tovar na konci (KOLO 230). */
export function poradieVariant<
  T extends Pick<Varianta, "je_vyrobna"> & { odbor?: Varianta["odbor"] },
>(varianty: readonly T[]): T[] {
  const nabytok = varianty.filter((v) => !jeTovarovaVarianta(v));
  return [
    ...nabytok.filter((v) => !v.je_vyrobna),
    ...nabytok.filter((v) => v.je_vyrobna),
    ...varianty.filter(jeTovarovaVarianta),
  ];
}

/** Meno ako na záložke — výroba (aj časť) a tovar menom, výpočet „Výpočet A". */
export function nazovVarianty(v: PoleVarianty): string {
  return v.je_cast || v.je_vyrobna || jeTovarovaVarianta(v) ? v.nazov : `Výpočet ${v.nazov}`;
}

/** Druh do riadku výberu — „časť výroby", „výrobná", „výpočet", „tovar". */
export function druhVarianty(v: PoleVarianty): string {
  if (jeTovarovaVarianta(v)) return "tovar";
  if (v.je_vyrobna) return v.je_cast ? "časť výroby" : "výrobná";
  return "výpočet";
}
